import axios from "axios";
import constants from "../../utils/constants";

const baseURL=constants.STORAGE;

const saveFiles = (request) => {
    
    return axios
        .post(`${baseURL}`, request,
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Accept': '*/*'
                }
            }
        );
};

const files = {
    saveFiles
};

export default files;


